import React from "react";
import COLORS from "../../constants/colors";

export default function SpellingSummaryCard({ results = [] }) {
  return (
    <div
      style={{
        marginTop: "1.2rem",
        background: "#FFFDF8",
        border: "1px solid #EFE5D5",
        borderRadius: "18px",
        padding: "1rem",
        textAlign: "left",
      }}
    >
      <div
        style={{
          fontWeight: 800,
          color: COLORS.text,
          marginBottom: "0.8rem",
        }}
      >
        本次拼写结果
      </div>

      {results.length === 0 ? (
        <div style={{ color: COLORS.subtext }}>暂无拼写数据</div>
      ) : (
        <div style={{ display: "grid", gap: "0.65rem" }}>
          {results.map((item, idx) => (
            <div
              key={`${item.wordId}-${idx}`}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
                padding: "0.7rem 0.8rem",
                borderRadius: "12px",
                background: "#fff",
                border: "1px solid #F1E7D8",
              }}
            >
              <div>
                <div style={{ fontWeight: 700, color: COLORS.text }}>
                  {item.word}
                </div>
                <div
                  style={{
                    color: COLORS.subtext,
                    fontSize: "0.88rem",
                    marginTop: "0.15rem",
                  }}
                >
                  拼错次数：{item.wrongCount || 0}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.45rem",
                  whiteSpace: "nowrap",
                }}
              >
                {item.starred ? (
                  <span style={{ color: COLORS.gold, fontSize: "1.1rem" }}>★</span>
                ) : (
                  <span style={{ color: "#DADADA", fontSize: "1.1rem" }}>☆</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}